import Card from "../../components/Card";
import Grid from "../../components/Grid";
import LightPageLayout from "../../components/Page/LightPageLayout";
import Spacer from "../../components/space/Spacer";
import Text from "../../components/Text";
import AnonymousLoginScreen from "./AnonymousLoginScreen";
import AnonymousSignupScreen from "./AnonymousSignupScreen";
import EmailAuthScreen from "./EmailAuthScreen";
import { getIndexLocation, useIndexLocationState } from "./navigation";

export default function SignupMethodScreen() {
    const { action, method } = useIndexLocationState();

    return (
        <LightPageLayout>
            <Text variant="heading">Commencez votre projet d'adoption</Text>
            <Spacer scale={4} />
            {action === null ? (
                <AuthChoiceStep />
            ) : action === "login" ? (
                method === null ? (
                    <LoginChoiceStep />
                ) : method === "anonymous" ? (
                    <AnonymousLoginScreen />
                ) : (
                    <EmailAuthScreen />
                )
            ) : method === null ? (
                <SignupChoiceStep />
            ) : method === "anonymous" ? (
                <AnonymousSignupScreen />
            ) : (
                <EmailAuthScreen />
            )}
        </LightPageLayout>
    );
}

function AuthChoiceStep() {
    return (
        <>
            <Text variant="body">Connectez-vous ou créez un compte.</Text>
            <Spacer scale={4} />
            <Spacer scale={4} />
            <Grid columns={1} gap={4}>
                <Card
                    title="Connexion"
                    action={getIndexLocation({
                        action: "login",
                        method: null,
                        signup_anonymous: null,
                    })}
                >
                    <Text variant="body">Retrouvez un projet déjà commencé.</Text>
                </Card>
                <Card
                    title="Inscription"
                    action={getIndexLocation({
                        action: "signup",
                        method: null,
                        signup_anonymous: null,
                    })}
                >
                    <Text variant="body">Créez un compte pour commencer votre projet.</Text>
                </Card>
            </Grid>
        </>
    );
}

function LoginChoiceStep() {
    return (
        <>
            <Text variant="body">Choisissez comment vous connecter.</Text>
            <Spacer scale={4} />
            <Spacer scale={4} />
            <Grid columns={1} gap={4}>
                <Card
                    title="Identifiant anonyme"
                    action={getIndexLocation({
                        action: "login",
                        method: "anonymous",
                        signup_anonymous: null,
                    })}
                >
                    <Text variant="body">
                        Utilisez l'identifiant unique qui vous a été donné à l'inscription.
                    </Text>
                </Card>
                <Card
                    title="Adresse email"
                    action={getIndexLocation({
                        action: "login",
                        method: "email",
                        signup_anonymous: null,
                    })}
                >
                    <Text variant="body">Un code à 6 chiffres vous sera envoyé par email.</Text>
                </Card>
            </Grid>
        </>
    );
}

function SignupChoiceStep() {
    return (
        <>
            <Text variant="body">Choisissez comment créer votre compte.</Text>
            <Spacer scale={4} />
            <Spacer scale={4} />
            <Grid columns={1} gap={4}>
                <Card
                    title="Continuer de façon anonyme"
                    action={getIndexLocation({
                        action: "signup",
                        method: "anonymous",
                        signup_anonymous: { step: "explain", code: null },
                    })}
                >
                    <Text variant="body">
                        Un identifiant unique vous sera donné une seule fois. Conservez-le
                        précieusement.
                    </Text>
                </Card>
                <Card
                    title="Continuer avec un email"
                    action={getIndexLocation({
                        action: "signup",
                        method: "email",
                        signup_anonymous: null,
                    })}
                >
                    <Text variant="body">Un code à 6 chiffres vous sera envoyé par email.</Text>
                </Card>
            </Grid>
        </>
    );
}
